import { Box, Typography } from '@mui/material'

import BarChart, { BarDataItem } from './barChart'

interface FareIntelligenceProps {
    fareOverview: string
    bookingAdvice: string
    weekendVsWeekday: string
    monthlyFares: BarDataItem[]
    monthlyChartTitle: string
    monthlyUnit: string
}

const FareIntelligence: React.FC<FareIntelligenceProps> = ({
    fareOverview,
    bookingAdvice,
    weekendVsWeekday,
    monthlyFares,
    monthlyChartTitle,
    monthlyUnit
}) => {
    return (
        <Box sx={{ mb: 3 }}>
            {fareOverview && (
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {fareOverview}
                </Typography>
            )}
            {monthlyFares.length > 0 && (
                <BarChart data={monthlyFares} title={monthlyChartTitle} unit={monthlyUnit} />
            )}
            {bookingAdvice && (
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    {bookingAdvice}
                </Typography>
            )}
            {weekendVsWeekday && (
                <Typography variant="body2" color="text.secondary">
                    {weekendVsWeekday}
                </Typography>
            )}
        </Box>
    )
}

export default FareIntelligence
export type { FareIntelligenceProps }
